<script>
  import { Bar } from 'vue-chartjs';

  export default {
    extends: Bar,
    props: {
      chartData: { type: Object, required: true },
      options: { type: Object, default: () => ({}) },
    },
    mounted() {
      this.renderChart(this.chartData, this.options);
    },
    watch: {
      chartData: {
        deep: true,
        handler() {
          this.$data._chart.destroy();
          this.renderChart(this.chartData, this.options);
        },
      },
    },
  };
</script>
